import { GREY_900, SPACING_2, remCalc } from '@mnd-frontend/ui';
import styled, { css } from 'styled-components';

export const boxShadow = css`
  box-shadow:
    0px 12px 16px 0px rgba(49, 73, 164, 0.08),
    0px 0px 3px 0px rgba(49, 73, 164, 0.1),
    0px 0px 2px 0px rgba(49, 73, 164, 0.14);
`;

const Header = styled.h1`
  color: ${GREY_900};
  font-family: Silka;
  font-size: ${remCalc(16)};
  line-height: ${remCalc(24)};
  font-style: normal;
  font-weight: 700;
`;

export const HeaderWithColoredUnderline = styled(Header)<{ $lineColor?: string }>`
  width: max-content;
  &:after {
    content: '';
    display: block;
    width: 100%;
    padding-top: ${remCalc(3)};
    border-bottom: 4px solid ${props => props.$lineColor || '#000'};
  }
`;

export const WrapperForEmptyReleases = styled.div<{ $position: 'top' | 'bottom' }>`
  position: absolute;
  display: flex;
  width: calc(100% - 4rem);
  gap: ${SPACING_2};
  ${props =>
    props.$position === 'top'
      ? css`
          top: 0;
        `
      : css`
          bottom: 0;
        `};
`;

export const EmptyPressRelease = styled.div<{
  $flex?: number;
  $height?: number;
  $boxShadow?: boolean;
  $background?: string;
  $border?: 'top' | 'bottom';
}>`
  flex: ${props => props.$flex || 1};
  height: ${props => props.$height || 10}px;
  border-radius: ${props => (props.$border === 'top' ? '6px 6px 0 0' : '0px 0px 6px 6px')};
  background: ${props => props.$background || 'white'};
  ${props =>
    props.$boxShadow &&
    css`
      box-shadow:
        0px 8.7px 11.6px 0px rgba(49, 73, 164, 0.08),
        0px 0px 2.175px 0px rgba(49, 73, 164, 0.1),
        0px 0px 1.45px 0px rgba(49, 73, 164, 0.14);
    `}
`;
